var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBought(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8C00E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_6968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1639 16.2682C12.0139 16.599 11.6194 16.7467 11.2833 16.599C10.9472 16.4514 10.7972 16.0631 10.9472 15.7322L13.8361 9.38792C13.9861 9.05725 14.3805 8.90932 14.7167 9.05758C15.0528 9.20584 15.2028 9.59409 15.0528 9.92495L12.1639 16.2682ZM16.9472 9.92495C16.7972 9.59409 16.9472 9.20584 17.2833 9.05758C17.6194 8.90932 18.0139 9.05725 18.1639 9.38792L21.0528 15.7322C21.2028 16.0631 21.0528 16.4514 20.7167 16.599C20.3805 16.7467 19.9861 16.599 19.8361 16.2682L16.9472 9.92495Z",
    fill: "#6800A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.9167 14.25L19.8361 16.268C19.9861 16.5988 20.3806 16.7465 20.7167 16.5988C21.0528 16.4512 21.2028 16.0629 21.0528 15.732L20.3778 14.25H23.1111C23.6028 14.25 24 14.641 24 15.125C24 15.609 23.6028 16 23.1111 16L21.6694 21.6738C21.4472 22.4531 20.7611 23 19.9444 23H12.0306C11.2389 23 10.5278 22.4531 10.33 21.6738L8.88889 16C8.39806 16 8 15.609 8 15.125C8 14.641 8.39806 14.25 8.88889 14.25H11.6222L10.9472 15.732C10.7972 16.0629 10.9472 16.4512 11.2833 16.5988C11.6194 16.7465 12.0139 16.5988 12.1639 16.268L13.0583 14.25H18.9167ZM13.3333 17.7254C13.3333 17.5066 13.1333 17.2879 12.8889 17.2879C12.6444 17.2879 12.4444 17.5066 12.4444 17.7254V20.3504C12.4444 20.6156 12.6444 20.7879 12.8889 20.7879C13.1333 20.7879 13.3333 20.6156 13.3333 20.3504V17.7254ZM15.5556 17.7254V20.3504C15.5556 20.6156 15.7556 20.7879 16 20.7879C16.2444 20.7879 16.4444 20.6156 16.4444 20.3504V17.7254C16.4444 17.5066 16.2444 17.2879 16 17.2879C15.7556 17.2879 15.5556 17.5066 15.5556 17.7254ZM19.5556 17.7254C19.5556 17.5066 19.3556 17.2879 19.1111 17.2879C18.8667 17.2879 18.6667 17.5066 18.6667 17.7254V20.3504C18.6667 20.6156 18.8667 20.7879 19.1111 20.7879C19.3556 20.7879 19.5556 20.6156 19.5556 20.3504V17.7254Z",
    fill: "#6800A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBought);
export default __webpack_public_path__ + "static/media/bought.14ae7daa3f8bc1f710fdb736c8f483be.svg";
export { ForwardRef as ReactComponent };